export default __webpack_public_path__ + "static/media/head04_en_sp.20ecc988.png";